import '../../css/promosep.css';
import { observer } from 'mobx-react-lite';
import State from '../data/State';
import { screen } from '../types/enums';
import BackButton from '../components/BackButton';

export default observer(() => {
  return (
    <div className="promosep">
      <BackButton callback={() => State.toBackScreen()} />
      <div className="promosep-1 promosep-block">
        <div className="promosep-1__content">
          <div>период проведения акции с 15.09.2025г. по 11.01.2026г.</div> 
        </div>
      </div>
      <div className="promosep-2 promosep-block">
        <div className="promosep-2__content">
          <div className="promosep-2-block-1">
            <h3>КУПИТЕ ПРОДУКТ</h3>
            <p>Santo Stefano в любом магазине РФ<br/> в период акции 15.09.25 - 11.01.26</p>
          </div>
          <div className="promosep-2-block-2">
            <h3>ЗАРЕГИСТРИРУЙТЕ ЧЕК</h3>
            <div onClick={() => State.setScreen(screen.SCAN_CHOOSE)}>зарегистрировать</div>
          </div>
          <div className="promosep-2-block-3">
            <h3>ПОЛУЧИТЕ ПОДАРОК</h3>
            <p>Цифровой стикерпак, мини-гайд по коктейлям </p>
          </div>
          <div className="promosep-2-block-4">
            <h3>ОПУБЛИКУЙТЕ ФОТО</h3>
            <p>с продуктом Santo Stefano<br/> на личной странице ВКонтакте с хештегом</p>
            <span>#Праздник_SantoStefano</span>
          </div>
          <div className="promosep-2-block-5">
            <h3>УЧАСТВУЙТЕ<br/> В РОЗЫГРЫШЕ ПРИЗОВ</h3>
          </div>
        </div>
      </div>
      <div className="promosep-3 promosep-block"></div>
      <div className="promosep-4 promosep-block">
        <div className="promosep-4__content">
          <div className="promosep-4--top">
              Для участия в розыгрыше<br/> главного приза участник должен<br/> зарегистрировать не менее 3 (трех)<br/> чеков за весь период акции<br/> и опубликовать фото с продукцией<br/> Santo Stefano на своей странице<br/> в социальной сети ВКонтакте с хештегом  
          </div>
          <div className="promosep-4--bottom">
            <div>
              Победитель номинации<br/> определяется открытым <br/> голосованием в официальном <br/> сообществе Santo Stefano <br/> в ВКонтакте в период <br/> <b>15.01.26 - 22.01.26</b>
            </div>
            <p>Приз номинации — iPhone 16</p>
          <span>#Праздник_SantoStefano</span>
          </div>
        </div>
      </div>
      <div className="promosep-5 promosep-block">
        
      </div>
      <div className="promosep-6 promosep-block">
        <div className="promosep-6__content">
          <div>
            Копите баллы за чеки <br/> и обменивайте их <br/> на мерч Santo Stefano
          </div>
        </div>
      </div>
      <div className="promosep-7 promosep-block">
        <div className="promosep-7--block-1">
          <p>В каких городах и магазинах можно совершить покупку? </p>
          <span>В любом магазине, на всей территории Российской Федерации.</span>
        </div>
        <div className="promosep-7--block-2">
          <p>Если в чеке несколько товаров Santo Stefano?</p>
          <span>Такой чек считается одним участием недели.</span>
        </div>
        <div className="promosep-7--block-3">
          <p>Какие сроки проведения акции?</p>
          <span>Общий срок проведения акции 15.09.2025 - 11.01.2026<br/> включительно.</span>
        </div>
        <div className="promosep-7--block-4">
          <p>Сколько чеков я могу зарегистрировать?</p>
          <span>Каждый участник может зарегистрировать<br/> неограниченное количество чеков.</span>
        </div>
        <div className="promosep-7--block-5">
          <p>Что делать, если чек не прошёл проверку?</p>
          <span>Загрузите его повторно, убедившись, что фото чёткое<br/> и читаемое или напишите нам в службу технической поддержки.</span>
        </div>
        <div className="promosep-7--block-6">
          <p>Нужен ли пост для участия?</p>
          <span>Да. Чтобы участвовать в еженедельных розыгрышах<br/> и спецноминации, нужно опубликовать фото с продуктом<br/> Santo Stefano в ВКонтакте с хештегом #Праздник_SantoStefano.</span>
        </div>
        <div className="promosep-7--block-7">
          <p>Как узнать победителей?</p>
          <span>Каждому победителю отправляется<br/> пуш-уведомление в чат-бот и в личных<br/> сообщениях социальной сети ВКонтакте.</span>
        </div>
        <div className="promosep-7--block-8">
          <p>Кто может участвовать?</p>
          <span>Любой совершеннолетний гражданин РФ (18+).</span>
        </div>
      </div>
    </div>
  );
});